module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURTMzM////8zMzJiYmPLy8lhYWERERGVlZX9/f9zc3L+/v4yMjKWlpbKysnJychufIU0AAAD6SURBVCjPddE9bsJAEAXgR4KNFRDCziJ+hYQlCrogN7QuQJSOxAFMmS5FREPFESwkamhoaJIrINHDDTgKnpl1vBS8wvJ+Xs/u7MLlHJf2as9v4OcBaez+P8zAcTJQEayTfwbmGpqwaPaApxBc8EOT1TeuArEVcukJFgxtvMjaHt4YmvgUcCOHoYGRho8SQw17DRdo6GvYCdTzXyxdY63hJjW6KMpYocKgUBXo0Rfa6S9tmRf5E5iiTOMO7FCgFVN3aW9f2QFtqRsPdpKBEijmZypQMMAJgvEDcAyIGRY5bAJKkoORJ9Dy0wwNeKearwZ0CSoGpLcrN+u6d0TpMi9LAJS5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/my Assessment.png
// module id = 315
// module chunks = 0